import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';

import './index.scss';
// import 'antd/dist/antd.css';
import { ConfigProvider } from 'antd';
import Es_ES from 'antd/locale/es_ES';

import dayjs from 'dayjs';
import 'dayjs/locale/es';
import isBetween from 'dayjs/plugin/isBetween';
import minMax from 'dayjs/plugin/minMax';

dayjs.locale('es');
dayjs.extend(isBetween);
dayjs.extend(minMax);

const container = document.getElementById('app');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

const validateMessages = {
  required: "'${label}' es requerido!",
};

root.render(
  // <React.StrictMode>
  <ConfigProvider
    locale={Es_ES}
    theme={
      {
        // components: {
        //   Table:{
        //     text
        //   }
        // }
      }
    }
    modal={{
      classNames: {
        header: 'siga-modal-header',
      },
    }}
    form={{ validateMessages }}
  >
    <App tab="home" />
  </ConfigProvider>,
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
